// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'
import * as ActiveStorage from '@rails/activestorage'
import 'channels'
import 'controllers'
import bootstrap from 'bootstrap/dist/js/bootstrap'
window.bootstrap = require('bootstrap/dist/js/bootstrap')
import '../stylesheets/application'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import intlTelInput from 'intl-tel-input'
import 'packs/jq-datatables.min.js'
import 'trix'
import '@rails/actiontext'
import 'packs/youtube'

Rails.start()
Turbolinks.start()
ActiveStorage.start()

document.addEventListener('turbolinks:load', initializeComponents)

document.addEventListener('turbolinks:before-cache', cleanupComponents)

document.addEventListener('ajax:success', () => {
  cleanupComponents()
  initializeComponents()
  instantiateDataTable()
})

function initializeComponents() {
  instantiateFlatpickr();
  instantiateBootstrapElements();
  showFlashMessages();
  showPageLoadModals();
  setUpIntlInput();
}

function cleanupComponents() {
  cleanupFlatpickr();
  cleanupDataTable();
  cleanupTooltips();
  cleanupPopovers();
  cleanupPageLoadModals();
}

function instantiateFlatpickr() {
  flatpickr('.flatpickr', {
    altInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'Y-m-d',
    disableMobile: true
  })

  flatpickr('.flatpickr-times', {
    altInput: true,
    altFormat: 'F j, Y h:i K', // Display format with time
    dateFormat: 'Y-m-d H:i', // Submission format with time
    enableTime: true, // Enable time selection
    time_24hr: false, // Use 12-hour format
    disableMobile: true
  })

  flatpickr('.flatpickr-inline', {
    altInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'Y-m-d',
    disableMobile: true,
    inline: true,
    minDate: 'today',
    monthSelectorType: 'static'
  })

  flatpickr('.flatpickr-autosave', {
    altInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'Y-m-d',
    disableMobile: true,
    minDate: 'today',
    monthSelectorType: 'static',
    onChange: function (selectedDates, dateStr, instance) {
      let baseUrl = this.element.dataset.url
      window.location.href = `${baseUrl}?date=${dateStr}`
    }
  })

  flatpickr('.flatpickr-multi', {
    altInput: true,
    mode: 'multiple',
    altFormat: 'F j, Y',
    dateFormat: 'Y-m-d',
    minDate: 'today',
    disableMobile: true
  })

  $('.flatpickr-mobile').flatpickr('destroy')
  $('.flatpickr-mobile').remove()
}

function cleanupFlatpickr() {
  $('.flatpickr').flatpickr('destroy')
  $('.flatpickr-multi').flatpickr('destroy')
  $('.flatpickr-inline').flatpickr('destroy')
  $('.flatpickr-autosave').flatpickr('destroy')
}

function instantiateDataTable() {
  if ($("#dataTable").length) {
    if ($.fn.DataTable.isDataTable("#dataTable")) {
      $("#dataTable").DataTable().destroy();
    }

    const sortColumn = $("#dataTable").data("sort-column") || 0;
    const sortDirection = $("#dataTable").data("sort-direction") || "asc";

    $("#dataTable").DataTable({
      paging: false,
      info: false,
      aaSorting: [[sortColumn, sortDirection]],
      stateSave: false,
      initComplete: function () {
        $("#tableLoadingSpinner").hide();
        $("#tableContainer").fadeIn();
      },
    });
  }
}

function cleanupDataTable() {
  if ($.fn.dataTable.isDataTable('#dataTable')) {
    $('#dataTable').DataTable().destroy()
  }
}

function instantiateBootstrapElements() {
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  )
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
  })

  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  )
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    var tooltip = new bootstrap.Tooltip(tooltipTriggerEl)
    tooltipTriggerEl.addEventListener('click', function () {
      tooltip.hide()
    })
  })

  var toastElList = [].slice.call(document.querySelectorAll('.toast'))
  var toastList = toastElList.map(function (toastEl) {
    return new bootstrap.Toast(toastEl)
  })
}

function cleanupTooltips() {
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  )
  tooltipTriggerList.forEach(function (tooltipTriggerEl) {
    const tooltip = bootstrap.Tooltip.getInstance(tooltipTriggerEl)
    if (tooltip) tooltip.dispose()
  })
}

function cleanupPopovers() {
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  )
  popoverTriggerList.forEach(function (popoverTriggerEl) {
    const popover = bootstrap.Popover.getInstance(popoverTriggerEl)
    if (popover) popover.dispose()
  })
}

function showFlashMessages() {
  var flashSuccess = document.querySelector('.flash-success')
  var successToast = bootstrap.Toast.getInstance(flashSuccess)
  if (flashSuccess != null) {
    successToast.show()
  }

  var flashError = document.querySelector('.flash-error')
  var errorToast = bootstrap.Toast.getInstance(flashError)
  if (flashError != null) {
    errorToast.show()
  }
}

function showPageLoadModals() {
  var modal = document.querySelector('#notificationModal')
  if (modal === null) {
    return false
  }

  var myModal = new bootstrap.Modal(modal, {
    keyboard: false,
    backdrop: 'static'
  })

  myModal.show()
}

function cleanupPageLoadModals() {
  var modal = document.querySelector('#notificationModal')
  if (modal === null) {
    return false
  }

  const myModal = bootstrap.Modal.getInstance(modal)
  if (myModal) myModal.dispose()
}

function setUpIntlInput() {
  const input = document.querySelectorAll('.intl-phone')
  if (input.length == 0) {
    return false
  }

  for (var i = 0; i < input.length; i++) {
    intlTelInput(input[i], {
      utilsScript:
        'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js',
      separateDialCode: true,
      hiddenInput: input[i].dataset.hiddeninput
    })
  }
}

require('trix')
require('@rails/actiontext')
